import { render, staticRenderFns } from "./Lgx175892346712893728.vue?vue&type=template&id=2c4577be&"
import script from "./Lgx175892346712893728.vue?vue&type=script&lang=js&"
export * from "./Lgx175892346712893728.vue?vue&type=script&lang=js&"
import style0 from "./Lgx175892346712893728.vue?vue&type=style&index=0&id=2c4577be&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports